module.exports = __webpack_public_path__ + "img/pic_8.42b60e45.jpg";